// French strings of the calendar (registered at module load; see docs/UI-CONTRACT.md §7).
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  'cal.eyebrow': 'MAECK OFFICE',
  'cal.viewLabel': 'Affichage',
  'cal.prev': 'Période précédente',
  'cal.next': 'Période suivante',
  'cal.prevMonth': 'Mois précédent',
  'cal.nextMonth': 'Mois suivant',
  'cal.prevWeek': 'Semaine précédente',
  'cal.nextWeek': 'Semaine suivante',
  'cal.todayTitle': 'Revenir à aujourd’hui (T)',
  'cal.hint.move': 'naviguer',
  'cal.hint.view': 'vue',
  'cal.hint.today': 'aujourd’hui',
  'cal.hint.close': 'fermer',
  'cal.search': 'Rechercher des tâches et routines…',
  'cal.searchLabel': 'Rechercher dans le calendrier',
  'cal.floor': 'Étage',
  'cal.floorCurrent': 'Étage actuel · {name}',
  'cal.floorAll': 'Tous les étages',
  'cal.filters': 'Filtrer par service',
  'cal.toggleRoutines': 'ROUTINES',
  'cal.toggleDone': 'FAITES',
  'cal.toggleRoutinesAria': 'Afficher les passages de routines',
  'cal.toggleDoneAria': 'Afficher les tâches terminées',
  'cal.deptChipAria': 'Afficher seulement {name}',
  'cal.summary.routines': { one: 'PASSAGE PRÉVU', other: 'PASSAGES PRÉVUS' },
  'cal.summary.paused': 'EN PAUSE',
  'cal.summary.scheduled': { one: 'PROGRAMMÉE', other: 'PROGRAMMÉES' },
  'cal.summary.done': { one: 'FAITE', other: 'FAITES' },
  'cal.summary.errors': { one: 'EN ERREUR', other: 'EN ERREUR' },
  'cal.summary.routinesTitle': 'Les exécutions à venir des routines actives sur la période affichée{capped}. Ce ne sont pas des tâches : chacune n’en crée une qu’au moment où elle passe.',
  'cal.summary.cappedNote': ' (au moins : la liste est limitée)',
  'cal.summary.pausedTitle': 'Les passages des routines en pause, qui ne s’exécuteront pas tant qu’elles le restent.',
  'cal.summary.scheduledTitle': 'Les tâches lancées pour plus tard sur la période.',
  'cal.summary.doneTitle': 'Les tâches terminées sur la période (les passages « rien à faire » des routines ne comptent pas).',
  'cal.summary.errorsTitle': 'Les échecs et blocages à traiter : ni réussis à un passage suivant de leur routine, ni ignorés, ni marqués réglés.',
  'cal.summary.legend': 'Que comptent ces chiffres ?',
  'cal.summary.legendTitle': 'Les chiffres de la période',
  'cal.summary.openBoard': 'Voir les erreurs dans le tableau des tâches',
  'cal.rail.title': 'ROUTINES',
  'cal.rail.empty': 'Aucune routine ici.',
  'cal.rail.emptyFiltered': 'Aucune routine ne correspond aux filtres.',
  'cal.rail.hint': 'Cliquez un jour pour y programmer une tâche, ou activez RÉPÉTER pour lancer une routine à partir de cette date. Cliquez une routine pour ne voir que ses passages.',
  'cal.rail.next': 'PROCHAIN {when}',
  'cal.rail.noNext': 'AUCUN PASSAGE PRÉVU',
  'cal.rail.paused': 'EN PAUSE',
  'cal.rail.approve': 'JE VALIDE AVANT D’AGIR',
  'cal.rail.edit': 'Modifier la routine « {title} »',
  'cal.rail.filterAria': 'Ne montrer que « {title} »',
  'cal.rail.manage': 'Gérer les routines',
  'cal.rail.toggle': { one: 'Routines ({n})', other: 'Routines ({n})' },
  'cal.routineFilter': 'Routine : {title}',
  'cal.routineFilterClear': 'Retirer le filtre de routine',
  'cal.loading': 'Chargement du calendrier…',
  'cal.unavailable': 'Le calendrier n’est pas encore disponible sur ce serveur.',
  'cal.error': 'Impossible de charger le calendrier.',
  'cal.fallback': 'Vue reconstituée à partir des routines et des tâches connues.',
  'cal.more': { one: '{n} de plus', other: '{n} de plus' },
  'cal.moreAria': { one: 'Voir {n} élément de plus le {day}', other: 'Voir {n} éléments de plus le {day}' },
  'cal.dayAria': '{day} — programmer une tâche',
  'cal.dayAriaRO': '{day}',
  'cal.dayEvents': { one: '{n} élément', other: '{n} éléments' },
  'cal.today': 'Aujourd’hui',
  'cal.emptyDay': 'Rien de prévu ce jour-là.',
  'cal.emptyPeriod': 'Rien de prévu sur cette période.',
  'cal.addOnDay': 'Programmer le {day}',
  'cal.ev.routine': '{time}',
  'cal.ev.routinePaused': '{time} · en pause',
  'cal.ev.scheduled': '{time} · programmée',
  'cal.ev.late': '{time} · en retard',
  'cal.ev.done': 'faite {time}',
  'cal.ev.failed': 'échec {time}',
  'cal.ev.blocked': 'bloquée {time}',
  'cal.ev.rejected': 'refusée {time}',
  'cal.ev.cancelled': 'annulée {time}',
  'cal.ev.superseded': 'échec résolu ensuite {time}',
  'cal.ev.ignored': 'ignorée {time}',
  'cal.ev.settled': 'réglée {time}',
  'cal.ev.running': '{time} · en cours',
  'cal.ev.executing': '{time} · exécution',
  'cal.ev.queued': '{time} · en attente',
  'cal.ev.awaiting_approval': '{time} · à valider',
  'cal.ev.aria': '{title} — {caption}',
  'cal.ev.routineAria': 'Routine {title} — {caption}',
  'cal.ro.title': 'Routine',
  'cal.ro.agent': 'Agent',
  'cal.ro.when': 'Rythme',
  'cal.ro.next': 'Prochain passage',
  'cal.ro.occurrence': 'Ce passage',
  'cal.ro.filter': 'Voir ses passages',
  'cal.ro.edit': 'Modifier',
  'cal.ro.run': 'Lancer maintenant',
  'cal.ro.ran': 'Routine lancée.',
  'cal.form.eyebrow': 'PROGRAMMER POUR',
  'cal.form.dept': 'Service',
  'cal.form.agent': 'Agent',
  'cal.form.agentAuto': 'Auto — le service choisit',
  'cal.form.time': 'Heure',
  'cal.form.model': 'Modèle',
  'cal.form.modelDefault': 'par défaut',
  'cal.form.advanced': 'Modèle (avancé)',
  'cal.form.text': 'Que faut-il faire ?',
  'cal.form.textPlaceholder': 'Envoyer le point hebdo à tous les clients actifs…',
  'cal.form.repeat': 'RÉPÉTER',
  'cal.form.repeatKind': 'Fréquence',
  'cal.form.kind.daily': 'Tous les jours',
  'cal.form.kind.weekdays': 'Jours ouvrés',
  'cal.form.kind.weekly': 'Chaque semaine',
  'cal.form.kind.monthly': 'Chaque mois',
  'cal.form.kind.hourly': 'Toutes les N heures',
  'cal.form.days': 'Jours',
  'cal.form.every': 'Toutes les',
  'cal.form.hours': 'h',
  'cal.form.until': 'jusqu’à',
  'cal.form.untilOptional': 'Fin (facultatif)',
  'cal.form.weekdaysOnly': 'En semaine seulement',
  'cal.form.approve': 'Je valide avant d’agir',
  'cal.form.approveHint': 'L’agent prépare un brouillon ; rien ne part sans votre accord.',
  'cal.form.autoHint': 'L’agent agit seul et termine la tâche.',
  'cal.form.approveLocked': 'Brouillon à valider : seul un responsable du service (niveau « Gérer ») peut faire agir l’agent sans validation.',
  'cal.form.submit': 'AJOUTER',
  'cal.form.submitRoutine': 'CRÉER LA ROUTINE',
  'cal.form.noDept': 'Vous ne pouvez programmer de tâche dans aucun service de cet étage.',
  'cal.form.empty': 'Décrivez ce qu’il faut faire.',
  'cal.form.past': 'Ce moment est déjà passé : choisissez une heure à venir.',
  'cal.form.pastDay': 'Ce jour est passé : une tâche ne peut être programmée que dans le futur. Une routine peut démarrer aujourd’hui.',
  'cal.form.timeRequired': 'Choisissez une heure.',
  'cal.form.previewTask': 'Tâche programmée · {when}',
  'cal.form.previewRoutine': 'Routine · {rhythm}',
  'cal.form.previewFirst': 'premier passage {when}',
  'cal.form.createdTask': 'Tâche programmée {when}.',
  'cal.form.createdRoutine': 'Routine créée : {description}.',
  'cal.form.close': 'Fermer',
  'cal.form.noRoutineAgent': 'Ce service n’a pas d’agent pour la routine.',
  'cal.mobile.add': 'Programmer',
  'cal.form.tooLong': '{max} caractères au plus.',
  'cal.form.badModel': 'Nom de modèle invalide (lettres, chiffres, . _ : - /).',
  'cal.form.repeatNeedsManage': 'Créer une routine demande le niveau « gérer » sur ce service.',
  'cal.form.noRun': 'aucun passage à venir',
  'cal.form.pastOnly': 'Ce jour est passé : on ne peut plus rien y programmer.',
  'cal.form.readOnly': 'Vous pouvez consulter ce calendrier, mais pas y programmer de tâche.',
  'cal.form.submitTitle': 'Ajouter (Ctrl + Entrée)',
  'cal.form.repeatAria': 'Répéter : créer une routine à partir de ce jour',
  'cal.form.everyUnit': 'heures',
  'cal.form.unavailable': 'Cette action n’est pas encore disponible sur ce serveur.',
  'cal.day.events': 'CE JOUR-LÀ',
  'cal.day.title': 'Programmer pour',
  'cal.weekdays': 'Jours de la semaine',
  'cal.grid': 'Calendrier du mois',
  'cal.gridWeek': 'Calendrier de la semaine',
  'cal.agenda': 'Agenda',
  'cal.agendaEmpty': 'Rien de prévu sur cette période. Touchez « Programmer » pour ajouter une tâche.',
  'cal.retry': 'Réessayer',
  'cal.periodLabel': 'Période affichée : {label}',
  'cal.floorAllOption': 'Tous les étages',
  'cal.floorOption': '{name}',
  'cal.ro.runsNone': 'jamais lancée',
  'cal.ro.last': 'Dernier passage',
  'cal.ro.openLast': 'Ouvrir la dernière tâche',
  'cal.ro.close': 'Fermer',
  'cal.rail.count': '{n}',
  'cal.truncated': 'Période trop chargée : une partie seulement est affichée.',
});
